<template>
  <div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{"players.sort.title" | translate}}</label>
      </div>
      <div class="field-body">
        <div class="field is-narrow">
          <div class="control">
            <div class="select is-fullwidth">
              <select v-model="sort" @change="loadPlayers">
                <option v-for="s in sorts" :value="s">{{`players.sort.${s.field}` | translate}} {{`players.sort.${s.order}` | translate}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">{{"players.search title" | translate}}</label>
      </div>
      <div class="field-body">
        <div class="field is-narrow">
          <div class="control">
            <input v-model="searchQuery" type="text" :placeholder="'players.search hint' | translate" class="input" />
          </div>
        </div>
        <div class="field is-narrow">
          <div class="control">
            <a class="button" @click="loadPlayers()">{{"players.search" | translate}}</a>
          </div>
        </div>
      </div>
    </div>

    <table class="table is-fullwidth is-hoverable is-size-7">
      <thead>
        <tr>
          <th>#</th>
          <th>{{"players.login" | translate}}</th>
          <th>{{"players.last login" | translate}}</th>
          <th>{{"players.last access" | translate}}</th>
          <th>{{"players.branch" | translate}}</th>
          <th>{{"players.balance" | translate}}</th>
          <th>{{"players.bonus" | translate}}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <template v-for="player in players">
          <tr v-for="(balance, index) in player.balances" v-if="player.balances && player.balances.length">
            <td :rowspan="player.balances.length" v-if="index == 0">
              <span v-if="player.isLocked" class="tag is-danger" :title="player.lockoutEndDate | datetime">LOCKED</span>
              {{player.number}}
            </td>
            <td :rowspan="player.balances.length" v-if="index == 0">
              <router-link :to="{ name: 'player', params: { playerId: player.id } }">
                {{ player.username }}
                <template v-if="player.alias"> / {{player.alias}}</template>
              </router-link>
            </td>
            <td :rowspan="player.balances.length" v-if="index == 0">{{player.lastLogin | datetime}}</td>
            <td :rowspan="player.balances.length" v-if="index == 0">{{player.lastAccess | datetime}}</td>
            <td><description :obj="balance" /></td>
            <td>{{balance.real | currency(balance.currency)}}</td>
            <td>{{balance.bonus | currency(balance.currency)}}</td>
            <td :rowspan="player.balances.length" v-if="index == 0">
              <a v-if="player.isLocked" class="button is-small" @click="unlockPlayer(player)">Unlock</a>
              <a v-else class="button is-warning is-small" @click="lockPlayer(player)">Lock</a>
            </td>
          </tr>
          <tr v-if="!player.balances || !player.balances.length">
            <td>{{player.number}}</td>
            <td>
              <router-link :to="{ name: 'player', params: { playerId: player.id } }">{{ player.username }}</router-link>
            </td>
            <td>{{player.lastLogin | datetime}}</td>
            <td>{{player.lastAccess | datetime}}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <a v-if="player.isLocked" class="button is-small" @click="unlockPlayer(player)">Unlock</a>
              <a v-else class="button is-warning is-small" @click="lockPlayer(player)">Lock</a>
            </td>
          </tr>
        </template>
      </tbody>
    </table>

    <pagination @change="loadPlayers();" ref="pagination" />
  </div>
</template>
<script>
  import playerService from '../../../services/player.service'

  import pagination from '../../common/pagination.vue'
  import description from '../../common/description.vue'

  export default {
    name: 'players-list',
    components: { pagination, description },
    data() {
      return {
        searchQuery: null,
        players: [],
        sorts: [
          { field: "name", order: "Ascending" },
          { field: "name", order: "Descending" },
          { field: "ll", order: "Ascending" },
          { field: "ll", order: "Descending" },
          { field: "la", order: "Ascending" },
          { field: "la", order: "Descending" },
          { field: "_reg", order: "Ascending" },
          { field: "_reg", order: "Descending" }
        ],
        sort: null
      }
    },
    async mounted() {
      this.sort = this.sorts[5];
      await this.loadPlayers();
    },
    methods: {
      async loadPlayers() {
        const filter = {
          pageNumber: this.$refs.pagination.pageNumber,
          pageSize: this.$refs.pagination.pageSize,
          sortBy: this.$data.sort.field,
          sortOrder: this.$data.sort.order,
          searchQuery: this.searchQuery
        };
        const data = await playerService.getByClient(filter);
        this.players = data.items;
        this.$refs.pagination.set(data.pageNumber, data.totalPages);
      },
      async lockPlayer(player) {
        if (confirm("Are you sure you want to lock player " + player.username + "?")) {
          await playerService.lock(player.id);
          await this.loadPlayers();
        }
      },
      async unlockPlayer(player) {
        if (confirm("Are you sure you want to unlock player " + player.username + "?")) {
          await playerService.unlock(player.id);
          await this.loadPlayers();
        }
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/client/players/list.vue